const GSTIN_REGEX = /^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

export const getContactNumberWarning = (value = "") => {
  const trimmed = String(value || "").trim();
  if (!trimmed || trimmed === "+91" || trimmed === "91") {
    return "";
  }

  const digits = trimmed.replace(/\D/g, "");

  if (!/^[\d\s()+\-./]+$/.test(trimmed)) {
    return "Use only numbers, spaces, +, -, brackets, dots, or slashes.";
  }

  if (digits.length < 6) {
    return "Enter at least 6 digits for mobile, landline, or telephone numbers.";
  }

  if (digits.length > 18) {
    return "Contact number looks too long. Please check it once.";
  }

  return "";
};

export const getGstinWarning = (value = "") => {
  const normalized = String(value || "").trim().toUpperCase();

  if (!normalized) {
    return "";
  }

  if (normalized.length !== 15) {
    return "GSTIN must be exactly 15 characters.";
  }

  if (!GSTIN_REGEX.test(normalized)) {
    return "Enter a valid GSTIN format, for example 27ABCDE1234F1Z5.";
  }

  return "";
};
